import { useState } from 'react';
import { PageHeader } from '../../../components/layout/Header';
import { Button } from '../../../components/ui';
import { Alert, AlertDescription, AlertTitle } from '../../../components/ui/alert';
import Spinner from '../../../components/ui/Spinner';
import type { AdminEmailTemplateRow } from '../../../domain/superadmin/types';
import { useAdminEmailTemplates } from '../hooks/useAdminEmailTemplates';
import { EmailTemplatePreviewModal } from './EmailTemplatePreviewModal';
import { EmailTemplateTestSendModal } from './EmailTemplateTestSendModal';
import { EmailTemplatesGrid } from './EmailTemplatesGrid';

export function AdminCommunicationsPage() {
    const { items, isLoading, error, refetch } = useAdminEmailTemplates();

    const [previewTemplate, setPreviewTemplate] = useState<AdminEmailTemplateRow | null>(null);
    const [testTemplate, setTestTemplate] = useState<AdminEmailTemplateRow | null>(null);

    const handlePreview = (template: AdminEmailTemplateRow) => {
        setPreviewTemplate(template);
    };

    const handleTest = (template: AdminEmailTemplateRow) => {
        setTestTemplate(template);
    };

    const handleSendTestFromPreview = (template: AdminEmailTemplateRow) => {
        setPreviewTemplate(null);
        setTestTemplate(template);
    };

    return (
        <div className="flex flex-col">
            <PageHeader
                title="Templates de E-mail"
                subtitle="Visualize e teste os e-mails transacionais enviados pela plataforma."
                hideBackButton
            />

            {isLoading && (
                <div className="flex items-center justify-center py-24">
                    <Spinner color="primary" size="lg" />
                </div>
            )}

            {!isLoading && error && (
                <Alert variant="destructive">
                    <AlertTitle>Erro ao carregar</AlertTitle>
                    <AlertDescription className="flex flex-col gap-3">
                        <p>{error}</p>
                        <Button variant="outline" size="sm" onClick={() => void refetch()}>
                            Tentar novamente
                        </Button>
                    </AlertDescription>
                </Alert>
            )}

            {!isLoading && !error && (
                <EmailTemplatesGrid
                    items={items}
                    onPreview={handlePreview}
                    onTest={handleTest}
                />
            )}

            <EmailTemplatePreviewModal
                template={previewTemplate}
                isOpen={previewTemplate !== null}
                onClose={() => setPreviewTemplate(null)}
                onSendTest={handleSendTestFromPreview}
            />

            <EmailTemplateTestSendModal
                template={testTemplate}
                isOpen={testTemplate !== null}
                onClose={() => setTestTemplate(null)}
            />
        </div>
    );
}
